<app-breadcrumb [title]="'Tipos de Programa'" [items]="['Pesv']" [active_item]="'Tipos de Programa'">
</app-breadcrumb>

<div class="container-fluid">
    <div class="card shadow-sm border-0">
        <div class="card-header bg-primary text-white d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <i class="icofont icofont-listine-dots me-2"></i>
                <h5 class="mb-0"><strong>TIPOS DE PROGRAMA </strong></h5>
            </div>
        </div>

        <div class="card">
            <div class="card-body">

                <!-- Filtros -->
                <div class="row mb-3">

                    <div class="col-md-3 mb-2">
                        <select class="form-select" [(ngModel)]="filtroEstado" (ngModelChange)="aplicarFiltro()">
                            <option [ngValue]="null">Todos los estados</option>
                            <option [ngValue]="1">Activo</option>
                            <option [ngValue]="0">Inactivo</option>
                        </select>
                    </div>
                    <div class="col-md-4 ms-auto">
                        <div class="input-group">
                            <input type="text" class="form-control" placeholder="Buscar por descripción..."
                                [(ngModel)]="filtro" (ngModelChange)="aplicarFiltro()" />
                        </div>
                    </div>
                    <div>
                        <!-- Skeleton loading -->
                        <div *ngIf="cargandoListado" class="text-center py-4">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Cargando...</span>
                            </div>
                        </div>

                        <!-- Tabla -->
                        <div class="table-responsive mt-2">
                            <table id="tablaTipoPrograma" class="table table-bordered table-hover align-middle">
                                <thead class="bg-primary text-white">
                                    <tr>
                                        <th class="text-center">DESCRIPCIÓN</th>
                                        <th class="text-center">ESTADO</th>
                                        <th class="text-center">ACCIONES</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="
              let tipo of tiposFiltrados
                | paginate: { itemsPerPage: pageSize, currentPage: page };
              let i = index
            ">
                                        <td class="text-center">{{ tipo.descripcion }}</td>
                                        <td class="text-center">
                                            <span class="badge"
                                                [ngClass]="Number(tipo.estado) === 1 ? 'bg-success' : 'bg-danger'">
                                                {{ Number(tipo.estado) === 1 ? "ACTIVO" : "INACTIVO" }}
                                            </span>
                                        </td>
                                        <td class="text-center">
                                            <div class="d-flex justify-content-center gap-1">
                                                <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                                    *ngIf="Number(tipo.estado) === 1" title="Editar"
                                                    (click)="abrirModalEditar(modalTipoPrograma, tipo)">
                                                    <i class="icofont icofont-pencil" style="font-size: .85rem;"></i>
                                                </button>
                                                <button
                                                    class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                                    *ngIf="Number(tipo.estado) === 1" title="Inactivar"
                                                    (click)="cambiarEstado(tipo, 0)">
                                                    <i class="icofont icofont-close" style="font-size: .85rem;"></i>
                                                </button>
                                                <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                                    *ngIf="Number(tipo.estado) !== 1" title="Activar"
                                                    (click)="cambiarEstado(tipo, 1)">
                                                    <i class="icofont icofont-check" style="font-size: .85rem;"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr *ngIf="tiposFiltrados.length === 0">
                                        <td colspan="4" class="text-center text-primary py-3">
                                            No se encontraron tipos de programa.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="d-flex justify-content-between align-items-center mt-4">
                            <div class="d-flex align-items-center">
                                <label for="pageSizeNombres" class="me-2">Mostrar:</label>
                                <select id="pageSizeNombres" class="form-select w-auto" [(ngModel)]="pageSize"
                                    (change)="page = 1">
                                    <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                                </select>
                                <span class="ms-2">registros por página</span>
                            </div>

                            <div class="text-center flex-grow-1">
                                Total Registros:
                                <a class="badge badge-primary"><b>{{ tiposFiltrados?.length || 0 }}</b></a>
                            </div>

                            <div class="text-end paginador-personalizado">
                                <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                                    [autoHide]="true" previousLabel="Anterior"
                                    nextLabel="Siguiente"></pagination-controls>
                            </div>
                        </div>

                        <div class="mt-4">
                            <div class="btn-showcase text-center">
                                <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                                    (click)="exportarExcel('tblNombrePrograma','listado_nombre_programa')">
                                    <i class="icofont icofont-file-excel"></i> EXCEL
                                </button>
                                <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                                    (click)="exportToPDF('tblNombrePrograma','listado_nombre_programa','Listado nombres de programa')">
                                    <i class="icofont icofont-file-pdf"></i> PDF
                                </button>
                                <button class="btn btn-outline-primary-2x" type="button"
                                    (click)="abrirModalCrear(modalTipoPrograma)">
                                    <i class="icofont icofont-plus me-1"></i> NUEVO
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Modal crear/editar -->
                <ng-template #modalTipoPrograma let-modal>
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">
                            {{ modoEdicion ? "Editar tipo de programa" : "Nuevo tipo de programa" }}
                        </h5>
                        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
                    </div>

                    <form [formGroup]="tipoProgramaForm" (ngSubmit)="guardar(modal)">
                        <div class="modal-body">
                            <div class="mb-3">
                                <label class="form-label text-black">Descripción <span
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="descripcion" maxlength="250"
                                    placeholder="Ej: PREVENTIVO, CORRECTIVO..." />
                                <div class="text-danger small mt-1" *ngIf="
            tipoProgramaForm.get('descripcion')?.touched &&
            tipoProgramaForm.get('descripcion')?.invalid
          ">
                                    La descripción es obligatoria.
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">
                                Cancelar
                            </button>
                            <button type="submit" class="btn btn-primary" [disabled]="guardando">
                                <span *ngIf="guardando" class="spinner-border spinner-border-sm me-1"></span>
                                {{ modoEdicion ? "Actualizar" : "Guardar" }}
                            </button>
                        </div>
                    </form>
                </ng-template>